// sites.$siteId.risks.tsx — T046
// Route : /sites/:siteId/risks — registre des risques d'un site.
// Le layout parent sites.$siteId.tsx gère le guard d'accès site/région.

import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { z } from "zod";

import { SitePage } from "@/presentation/pages/SitePage";

import { Route as SiteRoute } from "./sites.$siteId";

const risksSearchSchema = z.object({
  versionId: z.string().min(1).optional(),
  workUnitId: z.string().min(1).optional(),
  riskCategory: z.enum(["Physical", "Psychosocial"]).optional(),
  riskId: z.string().min(1).optional(),
});

interface RisksSearch {
  versionId?: string;
  workUnitId?: string;
  riskCategory?: "Physical" | "Psychosocial";
  riskId?: string;
}

export const Route = createFileRoute("/sites/$siteId/risks")({
  validateSearch: (search: Record<string, unknown>): RisksSearch => {
    const parsed = risksSearchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
  },
  component: function RisksRouteComponent() {
    const { siteId } = Route.useParams();
    const { site } = SiteRoute.useLoaderData();
    const { versionId, workUnitId, riskCategory, riskId } = Route.useSearch();
    const pathname = useRouterState({
      select: (state) => state.location.pathname,
    });
    const isRisksRootPath =
      pathname === `/sites/${siteId}/risks` ||
      pathname === `/sites/${siteId}/risks/`;

    if (isRisksRootPath) {
      return (
        <SitePage
          site={site}
          initialVersionId={versionId}
          initialWorkUnitId={workUnitId}
          initialRiskCategory={riskCategory}
          initialRiskId={riskId}
        />
      );
    }

    return <Outlet />;
  },
});

